
import { Component, Prop, VModel, Vue } from "vue-property-decorator";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import { SnackbarModule } from "@zelando/vuelando";
import { downloadXmlService } from "@/services/api/generate-xml.service";

const snackbarModule = getModule(SnackbarModule, store);

@Component
export default class MonthlyDownloadsDialog extends Vue {
  // ------> Props
  @VModel({ required: true, default: false, type: Boolean })
  isCancelMonthlyDownloadsOpen: boolean;

  @Prop({
    required: true,
    default: 0,
    type: String,
  })
  userMonthlyDownloadsEmail: string;
  @Prop({
    required: true,
    default: 0,
    type: Number,
  })
  userMonthlyDownloadsCount: number;
  @Prop({
    required: true,
    default: 0,
    type: Number,
  })
  selectedUserId: number;

  // ------> Getters
  get cancelMonthlyDownloadsActions(): unknown[] {
    const defActions = [
      {
        slotText: this.$tc("administration.Cancel"),
        plainType: "primary",
        key: "cancel",
        action: () => this.closeDialog(),
      },
      {
        slotText: this.$tc("administration.CancelMonthlyDownloadsBtnConfirm"),
        type: "primary-color",
        key: "save",
        disabled: !this.userMonthlyDownloadsCount,
        action: () => this.cancelMonthlyDownloadsSubmit(),
      },
    ];
    if (!(this.userMonthlyDownloadsCount > 0)) {
      defActions.pop();
    }
    return defActions;
  }
  get cancelMonthlyDownloadsTitle(): string {
    if (this.isCancelMonthlyDownloadsOpen) {
      return this.userMonthlyDownloadsEmail?.length > 0
        ? this.userMonthlyDownloadsEmail
        : this.$tc("administration.ErrorNoUserEmail");
    }
    return "";
  }
  get cancelMonthlyDownloadsDescription(): string {
    if (this.isCancelMonthlyDownloadsOpen && this.userMonthlyDownloadsCount) {
      return (
        this.$tc("administration.CancelMonthlyDownloadsDescription") +
        this.userMonthlyDownloadsCount
      );
    } else {
      return this.$tc("administration.CancelMonthlyDownloadsDescriptionNoData");
    }
  }

  // ------> Functions
  closeDialog(): void {
    this.isCancelMonthlyDownloadsOpen = false;
  }
  async cancelMonthlyDownloadsSubmit(): Promise<void> {
    const res = await downloadXmlService.clearMonthDownload(
      this.selectedUserId
    );
    snackbarModule.showSnackbar({
      message:
        res.status === 200
          ? this.$tc("administration.CancelMonthlyDownloadsOK")
          : this.$tc("administration.CancelMonthlyDownloadsKO"),
      type: res.status === 200 ? "success" : "error",
      timer: 5000,
    });
    this.closeDialog();
    this.$emit("reload");
  }
}
